// NEW: UI_REVAMP
import { Box, Flex } from '@chakra-ui/react';
import { useEffect } from 'react';
import { severAxiosInstance } from '../../api/query/api';
import { usePermissioStore } from '../../hooks/useStore';
import BalancePill from './BalancePill';
import Logo from './Logo';
import ServerTime from './ServerTime';

const Header = ({ display, borderRadius = '100px 16px 16px 100px', children }) => {
	const displayValue = display ?? { base: 'none', lg: 'block' };

	// zustand
	const setHasPermissionLocation = usePermissioStore((state) => state.setHasPermissionLocation);

	// set axios token
	useEffect(() => {
		const token = sessionStorage.getItem('accessToken');

		if (token) {
			severAxiosInstance.defaults.headers.common.Authorization = 'Bearer ' + token;
		}
	}, []);

	// location permission
	useEffect(() => {
		setHasPermissionLocation(true);
	}, []);

	return (
		<Box
			position='relative'
			bgGradient='linear-gradient(180deg, #F5D7A9 0%, #E28E10 10.42%, #E3CA89 25%, #E2A74C 69.79%, #4D3A1A 85.42%, #F5D7A9 100%)'
			p={0.5}
			borderRadius={borderRadius}
			display={displayValue}
		>
			<Box
				display='flex'
				bgGradient='linear-gradient(180deg, #EBEAFF 0%, #C5C3FE 25%, #C5C3FE 75%, #EBEAFF 100%)'
				flexDirection='row'
				justifyContent='space-between'
				alignItems='center'
				borderRadius='inherit'
				pr={2}
			>
				<Flex alignItems='center' justifyContent='start' gap={2.5}>
					<Logo />
					<ServerTime />
				</Flex>

				{children ? children : <BalancePill />}
			</Box>
		</Box>
	);
};

export default Header;
